import ENV from '../../base/env';
import { TChallengeWorkoutStatus } from '../../challenge/types';
import './ChallengeProgressCard.scss';

interface IChallengeProgressCardProps {
  label: string;
  type: TChallengeWorkoutStatus;
}

export default function ChallengeProgressCard({ label, type }: Readonly<IChallengeProgressCardProps>) {
  let picture: string | undefined;
  const cardClasses = ['challenge-card', type];
  switch (type) {
    case 'completed':
    case 'current-completed':
      picture = `${ENV.AssetsBaseUrl}/feature/exercise-icons/icon-checked.png`;
      break;
    case 'current':
      picture = `${ENV.AssetsBaseUrl}/feature/challenge/progress-current.webp`;
      break;
    case 'skipped':
      picture = `${ENV.AssetsBaseUrl}/feature/challenge/progress-skipped.webp`;
      break;
    case 'final-future':
      picture = `${ENV.AssetsBaseUrl}/feature/challenge/progress-final.webp`;
      break;
    case 'final-completed':
      picture = `${ENV.AssetsBaseUrl}/feature/challenge/progress-final-completed.webp`;
      break;
    default:
      break;
  }
  return (
    <div className={cardClasses.join(' ')}>
      <div className="challenge-top">{label}</div>
      <div className="challenge-middle">{picture ? <img alt={label} src={picture} /> : null}</div>
      <div className="challenge-bottom">&nbsp;</div>
    </div>
  );
}
